import { useEffect } from 'react';
import { format } from 'date-fns';
import useNoteStore from '../../store/noteStore';
import useCalendarStore from '../../store/calendarStore';
import NoteItem from './NoteItem';
import { EmptyStateDark, SkeletonNoteList } from '../Common';

const NoteList: React.FC = () => {
    const { currentDate } = useCalendarStore();
    const { notes, isLoading, fetchNotes, openEditor, deleteNote } = useNoteStore();

    useEffect(() => {
        const dateStr = format(currentDate, 'yyyy-MM-dd');
        fetchNotes(dateStr);
    }, [currentDate, fetchNotes]);

    const handleDelete = async (id: string) => {
        if (confirm('Bạn có chắc muốn xóa ghi chú này?')) {
            await deleteNote(id);
        }
    };

    if (isLoading && notes.length === 0) {
        return <SkeletonNoteList count={2} />;
    }

    if (notes.length === 0) {
        return (
            <EmptyStateDark
                type="notes"
                actionLabel="Tạo ghi chú"
                onAction={() => openEditor()}
            />
        );
    }

    return (
        <div className="px-4 py-2">
            <div className="flex items-center justify-between mb-3">
                <h3 className="text-white/80 text-sm font-medium">
                    Ghi chú ({notes.length})
                </h3>
            </div>
            <div className="space-y-2">
                {notes.map((note) => (
                    <NoteItem
                        key={note.id || note.localId}
                        note={note}
                        onEdit={openEditor}
                        onDelete={handleDelete}
                    />
                ))}
            </div>
        </div>
    );
};

export default NoteList;
